<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <h1 class="title-default">Configurações de estoque</h1>
        <p class="welcome-message">
          <button mat-icon-button type="button" (click)="voltar()">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Gerencie as definições padrão de estoque, entradas e avisos de suprimentos.
        </p>
      </div>
    </div>

    @if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
        <app-loading-box height="56" width="100%" marginTop="16"></app-loading-box>
      </div>
      <div class="section-container">
        <app-loading-box height="30" width="180" marginTop="0"></app-loading-box>
        <app-loading-box height="40" width="100%" marginTop="16"></app-loading-box>
      </div>
    } @else {
      <form [formGroup]="form">
        <div class="section-container">
          <div class="row mt-3">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle
                  class="app-toggle-compact"
                  formControlName="isEnviarEmailProdutosAbaixoEstoqueMinimo"
                  color="primary">
                  Enviar e-mail sobre produtos abaixo do estoque mínimo
                </mat-slide-toggle>
                <span class="info-text">
                  Envia um alerta diário às 06:30h (Horário de Brasília) se houver produtos abaixo do estoque mínimo.
                </span>
              </div>
            </div>

            @if (form.get('isEnviarEmailProdutosAbaixoEstoqueMinimo')?.value) {
              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>E-mails para receber os avisos</mat-label>
                  <input
                    matInput
                    formControlName="emailsDestinatariosAvisos"
                    placeholder="exemplo@empresa.com.br; financeiro@empresa.com.br" />

                  @if (form.get('emailsDestinatariosAvisos')?.hasError('required')) {
                    <mat-error>Informe ao menos um e-mail para receber os avisos.</mat-error>
                  }

                  @if (form.get('emailsDestinatariosAvisos')?.hasError('emailListInvalid')) {
                    <mat-error>Informe e-mails válidos separados por ponto e vírgula (;).</mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div class="toggle-content">
                <mat-slide-toggle
                  class="app-toggle-compact"
                  formControlName="isEditarQuantidadeImportacaoInventario"
                  color="primary">
                  Permitir editar quantidade lida na importação de inventário
                </mat-slide-toggle>
                <span class="info-text">
                  Permite alterar manualmente a quantidade lida durante o processo de importação do inventário.
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    }
  </div>
</div>

<app-footer-action
  [isLoadingSalvar]="isSaving"
  [isSalvarDisabled]="isLoading"
  (cancelar)="voltar()"
  (salvar)="salvar()"></app-footer-action>